import React, { useEffect, useState } from 'react';
import { useFetchOrganizations } from '../../hooks/api/organisation/organisation';
import { useAddLocation, useDeleteLocation, useFetchLocations, useUpdateLocation } from '../../hooks/api/location/location';
import { Pagination } from '@mui/material';

const locationsData = [
  // Example data (replace with your actual data fetching)
  {
    id: 1,
    name: 'Lagos Office 1',
    address: '456 Ikeja, Lagos',
    orgId: 'some-org-id-1',
    region: 'South West',
    state: 'Lagos',
    cordinate: { lng: 3.35, lat: 6.45 },
  },
  {
    id: 2,
    name: 'Abuja Office',
    address: '789 Garki, Abuja',
    orgId: 'some-org-id-2',
    region: 'North Central',
    state: 'Abuja',
    cordinate: { lng: 7.00, lat: 9.00 },
  },
];

const orgOptions = [ // Replace with your actual organization data/fetching
  { id: 'some-org-id-1', name: 'Acme Corp' },
  { id: 'some-org-id-2', name: 'Beta Industries' },
];

const LocationManagement = () => {
  const [filters, setFilters]=useState({
      orgId:"",
      search:"",
      pageNumber:1,
      pageSize:10
  }) 
    const fetchOrganisationAPI= useFetchOrganizations(filters) 
     
     const [organizations, setOrganizations] = useState([]);
    
 const { data: locations, isLoading, error } = useFetchLocations(filters);
  const addLocation = useAddLocation();
  const updateLocation = useUpdateLocation();
  const deleteLocation = useDeleteLocation();
  const [newLocation, setNewLocation] = useState({
    name: '',
    address: '',
    orgId: '',
    region: '',
    state: '',
    cordinate: { lng: '', lat: '' },
  });
  const [editLocation, setEditLocation] = useState(null);

  // ... (handleInputChange, handleAddLocation, handleDeleteLocation, handleEditLocation, handleUpdateLocation functions - same as previous example, but using the mutations)

  const orgOptions = [ // Replace with your actual organization data/fetching
    {id:"0a493a88-6208-4e02-93de-93daeb69273f", name: "Acme Corp"},
    {id:"b7b5c7d8-e9f0-4a2b-9c3d-4e5f6g7h8i9j", name: "Beta Industries"}
];

  const handleAddLocation = async (e) => {
    e.preventDefault();
    try {
      await addLocation.mutateAsync(newLocation);
      setNewLocation({
        name: '',
        address: '',
        orgId: '',
        region: '',
        state: '',
        cordinate: { lng: '', lat: '' },
      });
      alert("Location added successfully!");
    } catch (error) {
       console.error("Error adding location:", error);
      alert("Error adding location. Please try again.");
    }
  };

  const handleDeleteLocation = async (locationId) => {
    try {
      await deleteLocation.mutateAsync(locationId);
      alert("Location deleted successfully!");
    } catch (error) {
       console.error("Error deleting location:", error);
      alert("Error deleting location. Please try again.");
    }
  };


  const handleUpdateLocation = async () => {
    try {
      await updateLocation.mutateAsync(editLocation);
      setEditLocation(null);
      alert("Location updated successfully!");
    } catch (error) {
       console.error("Error updating location:", error);
      alert("Error updating location. Please try again.");
    }
  };


 



//   const [locations, setLocations] = useState(locationsData);
//   const [newLocation, setNewLocation] = useState({
//     name: '',
//     address: '',
//     orgId: '',
//     region: '',
//     state: '',
//     cordinate: { lng: '', lat: '' },
//   });
//   const [editLocation, setEditLocation] = useState(null);

  const handleInputChange = (e) => {
    if (e.target.name.startsWith('cordinate.')) {
      const coordPart = e.target.name.split('.')[1];
      setNewLocation({
        ...newLocation,
        cordinate: { ...newLocation.cordinate, [coordPart]: e.target.value },
      });
    } else {
      setNewLocation({ ...newLocation, [e.target.name]: e.target.value });
    }
  };

//   const handleAddLocation = () => {
//        // Basic validation (improve as needed)
//     if (!newLocation.cordinate.lng || !newLocation.cordinate.lat) {
//       alert("Longitude and Latitude are required.");
//       return;
//     }
//     setLocations([...locations, { id: locations.length + 1, ...newLocation }]);
//     setNewLocation({
//       name: '',
//       address: '',
//       orgId: '',
//       region: '',
//       state: '',
//       cordinate: { lng: '', lat: '' },
//     });
//   };

//   const handleDeleteLocation = (id) => {
//     setLocations(locations.filter((loc) => loc.id !== id));
//   };

  const handleEditLocation = (loc) => {
    setEditLocation({ ...loc });
  };

//   const handleUpdateLocation = () => {
//     // Basic validation (improve as needed)
//     if (!editLocation.cordinate.lng || !editLocation.cordinate.lat) {
//       alert("Longitude and Latitude are required.");
//       return;
//     }
//     setLocations(
//       locations.map((loc) => (loc.id === editLocation.id ? { ...loc, ...editLocation } : loc))
//     );
//     setEditLocation(null);
//   };


  useEffect(()=>{
   setOrganizations(fetchOrganisationAPI.data?.orgs)
      
    }, [ fetchOrganisationAPI.data])
    
    if (isLoading) {
        return <div>Loading locations...</div>;
      }
    
      if (error) {
        return <div>Error loading locations: {error.message}</div>;
      }
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">Location Management</h1>

      {/* Add Location Form */}
      <div className="bg-white rounded-lg shadow-md p-6 mb-4">
        <h2 className="text-xl font-semibold mb-2">Add New Location</h2>
        <div className="grid grid-cols-2 gap-4">
          <input
            type="text"
            name="name"
            placeholder="Location Name"
            value={newLocation.name}
            onChange={handleInputChange}
            className="border rounded px-3 py-2"
            required
          />
          <input
            type="text"
            name="address"
            placeholder="Address"
            value={newLocation.address}
            onChange={handleInputChange}
            className="border rounded px-3 py-2"
            required
          />
          {/* <select
            name="orgId"
            value={newLocation.orgId}
            onChange={handleInputChange}
            className="border rounded px-3 py-2"
            required
          >
            <option value="">Select Organization</option>
            {orgOptions?.map((org) => (
              <option key={org.id} value={org.id}>
                {org.name}
              </option>
            ))}
          </select> */}

          <select
            name="orgId"
            value={newLocation.orgId}
            onChange={handleInputChange}
            className="mx-4 border rounded px-3 py-2"
            required
          >
            <option value="">Select Organization</option>
            {organizations?.map((org) => (
              <option key={org?.id} value={org?.id}>
                {org?.name}
              </option>
            ))}
          </select>
          <input
            type="text"
            name="region"
            placeholder="Region"
            value={newLocation.region}
            onChange={handleInputChange}
            className="border rounded px-3 py-2"
            required
          />
          <input
            type="text"
            name="state"
            placeholder="State"
            value={newLocation.state}
            onChange={handleInputChange}
            className="border rounded px-3 py-2"
            required
          />

          <input
            type="number"
            name="cordinate.lng"
            placeholder="Longitude"
            value={newLocation?.cordinate?.lng}
            onChange={handleInputChange}
            className="border rounded px-3 py-2"
            required
          />
          <input
            type="number"
            name="cordinate.lat"
            placeholder="Latitude"
            value={newLocation?.cordinate?.lat}
            onChange={handleInputChange}
            className="border rounded px-3 py-2"
            required
          />
        </div>
        <button
          onClick={handleAddLocation}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4"
        >
          Add Location
        </button>
      </div>

      {/* Location Table */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-semibold mb-2">Location List</h2>
        <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr className='text-left'>
              <th className="px-4 py-2">Name</th>
              <th className="px-4 py-2">Address</th>
              <th className="px-4 py-2">Organization</th>
              <th className="px-4 py-2">Region</th>
              <th className="px-4 py-2">State</th>
              <th className="px-4 py-2">Longitude</th>
              <th className="px-4 py-2">Latitude</th>
              <th className="px-4 py-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {locations?.locations?.map((loc) => (
              <tr key={loc.id}>
                <td className="px-4 py-2">{loc.name}</td>
                <td className="px-4 py-2">{loc.address}</td>
                <td className="px-4 py-2">
                 {organizations?.find(org => org.id === loc.orgId)?.name|| "N/A"}
              
                  {/* {orgOptions.find((org) => org.id === loc.orgId)?.name || 'N/A'} Display org name */}
                </td>
                <td className="px-4 py-2">{loc.region}</td>
                <td className="px-4 py-2">{loc.state}</td>
                <td className="px-4 py-2">{loc?.cordinate?.lng}</td>
                <td className="px-4 py-2">{loc?.cordinate?.lat}</td>
                <td className="px-4 py-2 flex gap-2">
                  <button
                    onClick={() => handleEditLocation(loc)}
                    className="text-blue-500 hover:text-blue-700"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDeleteLocation(loc.id)}
                    className="text-red-500 hover:text-red-700"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
             <Pagination count={locations?.pagination?.totalPages} page={filters.pageNumber} onChange={ (event, value) => {
                      setFilters(prev=>({...prev, pageNumber:value}))
                    }} />
      </div>

      {/* Edit Location Form */}
      {editLocation && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-semibold mb-2">Edit Location</h2>
            <input
              type="text"
              name="name"
              value={editLocation.name}
              onChange={(e) => setEditLocation({ ...editLocation, name: e.target.value })}
              className="border rounded px-3 py-2 mb-2"
            />
            <input
              type="email"
              name="email"
              value={editLocation.email}
              onChange={(e) => setEditLocation({ ...editLocation, email: e.target.value })}
              className="border rounded px-3 py-2 mb-2"
            />
            <select
              name="role"
              value={editLocation.role}
              onChange={(e) => setEditLocation({ ...editLocation, role: e.target.value })}
              className="border rounded px-3 py-2 mb-2"
            >
              <option value="">Select Role</option>
              <option value="admin">Admin</option>
              <option value="client">Location</option>
              <option value="shopper">Shopper</option>
            </select>
            <input
              type="password"
              name="password"
              placeholder="New Password (Leave blank to keep current)"
              value={editLocation.password || ''}
              onChange={(e) => setEditLocation({ ...editLocation, password: e.target.value })}
              className="border rounded px-3 py-2 mb-2"
            />
         <select
            name="organization"
            value={editLocation.organization}
            onChange={handleInputChange}
            className="mx-4 border rounded px-3 py-2"
            required
          >
            <option value="">Select Organization</option>
            {organizations.map((org) => (
              <option key={org?.id} value={org?.id}>
                {org?.name}
              </option>
            ))}
          </select>
            <button
               onClick={handleUpdateLocation}
               className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2"
             >
               Update
             </button>
             <button
               onClick={() => setEditLocation(null)}
               className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
             >
               Cancel
             </button>
           </div>
         </div>
       )}
     </div>
   );
 };
 
 export default LocationManagement;
 